export const unitedStatesCountryCode = countries => {
  const rows = Array.isArray(countries) ? countries : [];
  const country = rows.find(item => String(item.A2 || "").toUpperCase() === "US")
    || rows.find(item => String(item.A3 || "").toUpperCase() === "USA")
    || rows.find(item => String(item.code || "") === "840")
    || rows.find(item => String(item.name || "").trim().toLowerCase() === "united states of america");
  return country ? country.code : null;
};
